/*eslint-disable no-undef */
import Queue from './queue';
import utils from './utils';
import conf from './conf';
import logger from './logger';
import huyaIco from 'common/nohash/ico-huya.png';

class WxApi {
    constructor(){
	    this.jssdkUrl = process.env.REACT_APP_HOST_WX;
        this.inited = false;
        this.queue = new Queue();
    }

    /**
     * 微信JSSDK初始化配置
     * @param params {Object} 签名等初始化信息
     */
    setWXConfig(params) {
        var self = this;

	    if(!utils.isWx) {
		    return;
	    }

	    if(window.wx){
		    self.initWX(params);
	    }else{
		    utils.load(this.jssdkUrl).then(function() {
			    self.initWX(params);
			    logger.log('wx jssdk load success');
		    }).catch(function(res){
			    logger.log('wx jssdk load error');
		    });
	    }
    }

	initWX(params) {
		let self = this;

		wx.config({
			debug: false, //utils.isDebug,
			appId: params.appId,
			timestamp: params.timestamp,
			nonceStr: params.nonceStr,
			signature: params.signature,
			jsApiList: ['chooseWXPay', 'onMenuShareQZone', 'onMenuShareQQ', 'onMenuShareAppMessage', 'onMenuShareTimeline', 'getNetworkType', 'getLocation', 'openLocation']
		});

		wx.ready(function(res){
			logger.log('微信初始化完成');
			params.callback && params.callback();
			self.inited = true;
			self.queue.run();
		});

		wx.error(function(res) {
			logger.log('微信初始化失败', res);
		})
	}

    /**
     * 设置分享信息
     */
    setWXShareInfo(shareInfo) {
        if(this.inited) {
            this.callSetWXShareInfo(shareInfo);
        }else{
            this.queue.add(function(){
                this.callSetWXShareInfo(shareInfo);
            }.bind(this));
        }
    }
    /**
     * 设置分享信息
     */
    callSetWXShareInfo( shareInfo ) {
        shareInfo = shareInfo || {};
        wx.ready(function () {

            var shareData = {
                title: shareInfo.title  ||  '高颜值萝莉等你来撩-虎牙直播', // 分享标题
                desc: shareInfo.desc || '颜值美女，英雄大神，顶尖赛事尽在虎牙直播！', // 分享描述
                link: shareInfo.link || window.location.href.replace('/subscriber',''), // 分享链接
                imgUrl: shareInfo.imgUrl || 'http://hd.huya.com/' + huyaIco, // 分享图标
                type: '', // 分享类型,music、video或link，不填默认为link
                dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
                success: function () {
                    shareInfo.success && shareInfo.success();
                },
                cancel: function () {
                    // 用户取消分享后执行的回调函数
                    shareInfo.cancel && shareInfo.cancel();
                }
            };
            var shareTimelineData =  Object.assign( {}, shareData);

            if( shareInfo.page === 'room' ){
                shareTimelineData.title += '-虎牙直播'
            };
            wx.onMenuShareTimeline(shareTimelineData);//分享到朋友圈”
            wx.onMenuShareAppMessage(shareData);//“分享给朋友”
            wx.onMenuShareQQ(shareData);//“分享到QQ朋友”
            wx.onMenuShareQZone(shareData);//分享到QQ空间”
            wx.onMenuShareWeibo(shareData);//“分享到腾讯微博”

        });
    }

    /**
     * 初始化微信JSSDK
     * @param ready {Function} 微信初始后的调用
     */
    init(ready) {
        var oCallback = {},
            self = this;

        if(!utils.isWx || this.inited){
            return;
        }

        if(typeof ready === 'function') {
            oCallback.callback = ready;
        }

        this.getJsapiSignPackage(function() {
            self.setWXConfig(Object.assign(oCallback, self.wxSignInfo));
        });
    }

    /**
     * 获取微信初始化所需信息
     * @param callback 回调函数
     */
    getJsapiSignPackage(callback) {
        let self = this;

        utils.jsonp({
            url: conf.dataUrls.pay,
            data: {
                do: 'getJsapiSignPackage'
            }
        }).done(function(res) {
            if(res.status === 200) {
                self.wxSignInfo = res.data.jsapiSignPackage;
                callback && callback(self.wxSignInfo);
            }
        });
    }

    /**
     * 获取网络状态
     */
    getNetWorkType(fn) {
        if(this.inited) {
            this.callWxGetNetWorkType(fn);
        }else{
            this.queue.add(function(){
                this.callWxGetNetWorkType(fn);
            }.bind(this));
        }
    }

    /**
     * 调用wx接口获取网络状态
     * @param fn
     */
    callWxGetNetWorkType(fn) {
        wx.getNetworkType({
            success: function (res) {
                fn && fn();
               /* var networkType = res.networkType; // 返回网络类型2g，3g，4g，wifi
                if(networkType === 'wifi') {
                    fn && fn();
                }*/
            }
        });
    }

    /**
     * 获取地址位置
     */
    getLocation(fn) {
        if(this.inited) {
            this.callWxGetLocation(fn);
        }else{
            this.queue.add(function(){
                this.callWxGetLocation(fn);
            }.bind(this));
        }
    }

    /**
     * 微信获取地址位置接口
     * @param fn
     */
    callWxGetLocation(fn) {
        wx.getLocation({
            type: 'wgs84',
            success: function (res) {
                res._returnCode = 1;
                fn && fn(res);
            },
            fail: function () {
                fn && fn({_returnCode: -1, description: '获取地理位置失败'});
            },
            cancel: function () {
                fn && fn({_returnCode: 0, description: '用户拒绝授权获取地理位置'});
            }
        });

    }
}

export default new WxApi();



// WEBPACK FOOTER //
// ./src/common/js/wxapi.js